/**
 * Boost App Placeholder Replacer
 * Replaces the Boost app's default placeholder images with custom ones
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    appPlaceholderUrl: 'https://cdn.shopify.com/extensions/201f4d7b-8d39-43a4-82de-e6f412341695/0.0.0/assets/boost-pfs-no-image.jpg',
    customPlaceholderUrl: 'https://momo-handles-demo.myshopify.com/cdn/shop/files/Image_Placeholder_5efacce9-bac0-4d29-9496-5fb0ceb288ec.png?v=1761282357&width=940',
    scanInterval: 500, // ms
    scanDuration: 10000, // ms (10 seconds)
    debug: false // Set to false to disable console logs
  };

  /**
   * Replace placeholder image with custom image
   */
  function replacePlaceholder(img) {
    if (img && img.src && img.src.includes(CONFIG.appPlaceholderUrl)) {
      if (CONFIG.debug) {
        console.log('🖼️ Replacing placeholder:', img.src);
      }
      img.src = CONFIG.customPlaceholderUrl;
      if (img.srcset) {
        img.srcset = '';
      }
    }
  }

  /**
   * Scan all images on the page
   */
  function scanAllImages() {
    const allImages = document.querySelectorAll('img');
    let count = 0;
    
    allImages.forEach(img => {
      if (img.src && img.src.includes(CONFIG.appPlaceholderUrl)) {
        replacePlaceholder(img);
        count++;
      }
    });
    
    if (count > 0 && CONFIG.debug) {
      console.log('✅ Replaced', count, 'placeholder(s)');
    }
    
    return count;
  }

  /**
   * Set up MutationObserver to watch for dynamically added images
   */
  function observeImages() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Check for added nodes
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Check if node is an img
            if (node.tagName === 'IMG') {
              replacePlaceholder(node);
            }
            // Check for img descendants
            const images = node.querySelectorAll ? node.querySelectorAll('img') : [];
            images.forEach(img => replacePlaceholder(img));
          }
        });
        
        // Check for src attribute changes
        if (mutation.type === 'attributes' && 
            mutation.target.tagName === 'IMG' && 
            mutation.attributeName === 'src') {
          replacePlaceholder(mutation.target);
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
    
    if (CONFIG.debug) {
      console.log('👀 MutationObserver active - watching for Boost app images');
    }
  }

  /**
   * Initialize the placeholder replacer
   */
  function init() {
    if (CONFIG.debug) {
      console.log('🚀 Boost Placeholder Replacer initialized');
    }
    
    // Initial scan
    scanAllImages();
    
    // Set up observer for dynamic content
    observeImages();
    
    // Periodic scanning for async-loaded content
    const maxChecks = CONFIG.scanDuration / CONFIG.scanInterval;
    let checkCount = 0;
    
    const interval = setInterval(() => {
      scanAllImages();
      checkCount++;
      
      if (checkCount >= maxChecks) {
        clearInterval(interval);
        if (CONFIG.debug) {
          console.log('✓ Periodic scanning complete');
        }
      }
    }, CONFIG.scanInterval);
  }

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

